/**
 * Reopening the cookie banner (the footer's "Cookie settings"), so withdrawing consent is as easy as giving it
 * (GDPR Art. 7(3)). The banner lives in Layout and the footer in each page, so they talk through a window event.
 */
const OPEN_COOKIE_SETTINGS_EVENT = 'gd:open-cookie-settings';

export function openCookieSettings(): void {
  window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
}

export function onOpenCookieSettings(handler: () => void): () => void {
  window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, handler);
  return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, handler);
}

// First-party cookies the optional tools set: GA4 (_ga, _ga_<id>, _gid, _gat), Google Ads (_gcl_*) and
// Microsoft Clarity (_clck, _clsk). Third-party cookies on Google's and Microsoft's domains can't be reached here.
const OPTIONAL_COOKIE = /^(_ga|_gid|_gat|_gcl_|_clck|_clsk)/;

/** Deletes the optional tools' cookies on this host and each parent domain (GA4 sets them on `.gizmodata.com`). */
export function deleteOptionalCookies(): void {
  const labels = window.location.hostname.split('.');
  const domains = [''];
  for (let i = 0; i < labels.length - 1; i++) {
    domains.push(`; Domain=.${labels.slice(i).join('.')}`);
  }
  for (const cookie of document.cookie.split(';')) {
    const name = cookie.split('=')[0].trim();
    if (!OPTIONAL_COOKIE.test(name)) continue;
    for (const domain of domains) {
      document.cookie = `${name}=; Path=/; Max-Age=0${domain}`;
    }
  }
}
